import { Button, Div, H2, Modal } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { prop } from 'ramda'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { savePriorities } from 'api/playbooks'
import PlaybookPriorityTable from 'components/PlaybookPriorityTable'
import { getOrgWorkspaces } from 'modules/workspace/selectors'
import { getWorkspacesWithChatPlaybooksWrite } from 'utils/access'

import './style.css'

const SelectPriorities = ({
  onChange,
  showTransientNotification,
  togglePrioritiesModal,
  playbookType,
}) => {
  const [isDirty, setIsDirty] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [priorityPayload, setPriorityPayload] = useState({})

  const orgWorkspaces = useSelector(getOrgWorkspaces)
  const writableWorkspaces = getWorkspacesWithChatPlaybooksWrite().map(
    (id) => orgWorkspaces[id]
  )

  const [selectedWorkspace, setSelectedWorkspace] = useState(
    writableWorkspaces[0]
  )

  const handleWorkspaceChange = setSelectedWorkspace

  const canPickWorkspace = writableWorkspaces.length > 1
  const workspacePicker = (
    <>
      {' '}
      for{' '}
      <Select
        className="playbooks-prioritized-workspace-select"
        value={selectedWorkspace}
        options={writableWorkspaces}
        getOptionLabel={prop('name')}
        getOptionValue={prop('id')}
        onChange={handleWorkspaceChange}
        inlineWidth="200"
        inline
      />
    </>
  )

  async function doSave() {
    try {
      setIsSaving(true)
      await savePriorities(
        selectedWorkspace.id,
        {
          priorityList: priorityPayload.idPriorityList,
        },
        { type: playbookType }
      )
      onChange()
      togglePrioritiesModal()
      showTransientNotification({
        message: 'Priorities saved successfully',
        type: 'success',
      })
    } catch (error) {
      setIsSaving(false)
      console.warn(error)
      showTransientNotification({
        message: `Could not save changes`,
        type: 'error',
      })
    }
  }

  return (
    <Div className="playbooks-prioritized">
      <Div className="playbooks-prioritized-container">
        <H2>Set priority{canPickWorkspace && workspacePicker}</H2>
        <Div className="playbooks-priority-table-wrapper">
          <PlaybookPriorityTable
            selectedWorkspace={selectedWorkspace}
            setHasPriorityChanged={setIsDirty}
            setPriorityPayload={setPriorityPayload}
            priorityPayload={priorityPayload}
            type={playbookType}
          />
        </Div>
      </Div>

      <Div className="playbooks-prioritized-list--action-banner">
        <Button
          disabled={!isDirty}
          onClick={doSave}
          type="secondary"
          loading={isSaving}
        >
          Save
        </Button>
        <Button
          disabled={isSaving}
          onClick={togglePrioritiesModal}
          type="tertiary"
        >
          Cancel
        </Button>
      </Div>
    </Div>
  )
}

export default function PrioritizeModal({
  onChange,
  orgUsers,
  showTransientNotification,
  togglePrioritiesModal,
  playbookType,
}) {
  return (
    <Modal onClose={togglePrioritiesModal} open={true} size="fullscreen">
      <SelectPriorities
        onChange={onChange}
        orgUsers={orgUsers}
        showTransientNotification={showTransientNotification}
        togglePrioritiesModal={togglePrioritiesModal}
        playbookType={playbookType}
      />
    </Modal>
  )
}
